var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.saveFile}},[_vm._v("Export local annot coverage")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }